<template lang="pug">
  .page(style="padding-top: 50px;")
    br
    .container-fluid(:class='sessionGetDisplayClass("content")')
      .row.backgroundRow
        .col-lg-12(style="padding-top: 60px; color: white;").searchHeader
          h3.center WELCOME TO DATA.HAWAII.EDU,
            template {{ sessionIsLoggedIn ? userFirstName.toUpperCase() : 'GUEST' }}
              img.mb-2.ml-1(v-if='isStaff', src='@assets/img/verified.png', title='IRAPO Staff 😉')
          .row.spacer.box(v-if='!sessionIsLoggedIn')
            .col-lg-12.d-sm-block.center
              font-awesome-icon.icon.mx-1(:icon='["fa", "user"]', size='1x')
              a.link(@click='doLogin').white Login to access resources for faculty and staff.
          .row.spacer.box(v-if='sessionIsLoggedIn')
              .col-lg-12.d-sm-block.center
                  div.center
                    font-awesome-icon.mx-1(:icon='getISatComplianceIcon', :class='getISatComplianceColor', :title='getISatComplianceTitle')
                    | UH Information Security Awareness Training (ISAT) Compliant
      br
      .row.searchContainer.hide
        .col-lg-12
          div#rdapp.center.searchWrapper
            .search-wrapper
              .row
                .col-lg-12
                  div Report ID or Shortcut ID:
                    input#reports-search(type="text", v-model="search", placeholder="Report ID",style="margin-left: 20px;")
                    button.btn.btn-submit(style="margin-left:10px; vertical-align: center;", @click="searchIds()") Go!
                    div(v-if="notFound" variant="danger" dismissable) Report ID/Shortcut Not Found
      hr

      .card-deck
        .card(:class='sessionGetDisplayClass(["body", "content"])')
          .card-header(:class='sessionGetDisplayClass(["body", "content", "card-header"])')
            | SITE MAP
          .card-body.sitemap
            p(style="padding-top: 5px")
              ul
                li.areaItem
                  router-link.link(to="/reports") Management and Planning Support (MAPS)
                  br
                  .small.font-italic Standard Reports
                li.areaItem
                  router-link.link(to="/datacollection") Data Collection Center (DCC)
                  font-awesome-icon.text-danger.lock(:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
                  br
                  .small.font-italic Online collection and reporting of VP for Academic Strategy metrics for planning and compliance purposes.
                li.areaItem.hide
                  router-link.link(to="/studentsuccess") Student Success Data Resource Center (SSDRC) - COMING SOON
                  font-awesome-icon.text-danger.lock(:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
                  br
                  .small.font-italic Collection of UH System level training material, reports, and resources for student success & Institutional Research Training Material
                li.areaItem.hide Federal Student Compliance Reports (FSCR) - COMING SOON
                  .small.font-italic Central location for federal student complication reporting.
                li.areaItem
                  router-link.link(to="/opendata") Open Data
                  .small.font-italic Collection of public datasets.
                li.areaItem
                  router-link.link(to="/flc") Faculty DFW Placeholder
                  .small.font-italic Faculty DFW Report
                li.areaItem
                  router-link.link(to="/reportingDefinitions") Student Reporting Definitions
                  .small.font-italic General definitions regarding student reporting.
                li.areaItem
                  router-link.link(to="/dataDictionary") Data Dictionaries
                  .small.font-italic Collection of data dictionaries.
                li.areaItem
                  router-link.link(to="/freezeSchedule") Freeze Schedule
                  .small.font-italic Schedule for freezing student data regarding CENSUS and End-Of-Semester (EOS) counts.

        //- wrap every cards on small
        .w-100.d-none.d-xs-block.d-sm-none

        .card(:class='sessionGetDisplayClass(["body", "content"])')
          .card-header(:class='sessionGetDisplayClass(["body", "content", "card-header"])') COMMONLY USED REPORTS
          .card-body
            span.header-text DAILY STUDENT REPORTS
            .subtext.font-italic Reports updated daily during opening enrollment periods
            ul.list
              template(v-for="report in this.daily")
                li
                  router-link.link(v-if="!report.linkout && report.linkout !== 'N'", :to="report.location") {{ report.name }}
                  ExternalLink.link(v-else, :href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                  font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
            span.header-text STUDENT DATA REPORTS
            .subtext.font-italic Official reports updated at CENSUS and End-of-Semester.
            ul.list
              template(v-for="report in this.strategic")
                li
                  router-link.link(v-if="!report.linkout && report.linkout !== 'N'", :to="report.location", :id='"home-link-" + report.name') {{ report.name }}
                  ExternalLink.link(v-else, :href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                    font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
            span.header-text ACADEMIC AFFAIRS
            .subtext.font-italic
            ul.list
              template(v-for="report in this.planning")
                li
                  router-link.link(v-if="!report.linkout && report.linkout !== 'N'", :to="report.location") {{ report.name }}
                  ExternalLink.link(v-else, :href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                  font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
            span.header-text OTHER
            .subtext.font-italic All other reports of interest.
            ul.list
              template(v-for="report in this.other")
                li
                  router-link.link(v-if="!report.linkout && report.linkout !== 'N'", :to="report.location") {{ report.name }}
                  ExternalLink.link(v-else, :href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                  font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )

        //- wrap every cards
        .w-100.d-none.d-sm-block.d-lg-none

        .card(:class='sessionGetDisplayClass(["body", "content"])')
          .card-header(:class='sessionGetDisplayClass(["body", "content", "card-header"])')
            | DASHBOARDS & ADHOCS
          .card-body
            span.header-text GENERAL
            span.subtext.font-italic List of dashboards for decision making and adhoc support.
            ul.list
              template(v-for="report in this.dashboards.public")
                li
                  router-link.link(v-if="!report.linkout && report.linkout !== 'N'", :to="report.location") {{ report.name }}
                  ExternalLink.link(v-else, :href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                  font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
            template(v-if="sessionIsLoggedIn")
              span.header-text INTERNAL
              ul.list
                template(v-for="report in this.dashboards.internal")
                  li
                    router-link.link(v-if="!report.linkout && report.linkout !== 'N'", :to="report.location") {{ report.name }}
                    ExternalLink.link(v-else, :href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                      font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
            template(v-if="sessionIsLoggedIn")
              p.header-text ADHOC
              ul.list
                template(v-for="report in this.dashboards.adhoc")
                  li(v-if="(sessionIsLoggedIn && report.hide==='Y') || !report.hide ")
                    router-link.link(v-if="!report.linkout && report.linkout !== 'N'", :to="report.location") {{ report.name }}
                    ExternalLink.link(v-else, :href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                      font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
                    div.updated {{ report.lastUpdated }}, last updated

        //- wrap every cards
        .w-100.d-xs-block.d-sm-none.d-md-none.d-lg-block.d-xl-none
        .card(:class='sessionGetDisplayClass(["body", "content"])')
          .card-header(:class='sessionGetDisplayClass(["body", "content", "card-header"])')
            | FEATURED REPORTS
          .card-body
              span.header-text ENROLLMENT REPORTS
              ul.list
                template(v-for="report in this.featured.census")
                  li
                    ExternalLink.link(:href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"')
                      span(v-html="report.name")
                      font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
              span.header-text DAILY STUDENT REPORTS
              ul.list
                template(v-for="report in this.featured.opening")
                  li
                    ExternalLink.link(:href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"')
                      span(v-html="report.name")
                      font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
              span.header-text COURSE OFFERING AND STUDENT REGISTRATION PATTERNS BY MODALITY
              ul.list
                template(v-for="report in this.featured.modality")
                  li
                    ExternalLink.link(:href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"')
                      span(v-html="report.name")
                      font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )
              span(v-if="this.featured.other").header-text OTHER REPORTS
              ul.list
                template(v-for="report in this.featured.other")
                  li
                    ExternalLink.link(:href="report.location", :target='report.linkout ==="Y" ? "_blank" : "_self"') {{ report.name }}
                      font-awesome-icon.text-danger.lock(v-if="report.internal === 'Y'",:icon='["fas", "lock"]', size='sm', aria-label="Restricted to UH Login only", title="Restricted to UH Login only" )

      br
</template>

<script>
import { concat, filter, find, flatten, forEach, groupBy, has, isEmpty, keys, map, sortBy } from 'lodash';
import { mapGetters } from 'vuex';
import analytics from '@api/analytics';
import resource from '@api/resource';
import oidcClient from '@api/oidcClient';
import storage from '@api/storage';
import ExternalLink from '@components/ExternalLink';

const _ = { concat, filter, find, flatten, forEach, groupBy, has, isEmpty, keys, map, sortBy };

export default {
  name: 'Home',
  components: {
    ExternalLink
  },
  data: () => ({
    reportList: {},
    slide: 0,
    notFound: false,
    sliding: '',
    search: '',
  }),
  computed: {
    ...mapGetters('content', [
      'tableOfContents'
    ]),
    ...mapGetters('session', [
      'session',
      'sessionDisplayIsDark',
      'sessionGetDisplayClass',
      'sessionHasRole',
      'sessionProperty',
      'sessionHasToken',
      'sessionUsername',
      'sessionIsISatCompliant',
      'sessionIsLoggedIn'
    ]),
    daily: function (){
      if(this.reportList.items){
        return this.reportList.items.reports.daily;
      }
      return this.reportList;
    },
    userFirstName: function () {
      return this.sessionProperty('given_name') || this.sessionProperty('preferred_username');
    },
    strategic: function (){
      if(this.reportList.items){
        return this.reportList.items.reports.strategic;
      }
      return this.reportList;
    },
    planning: function (){
      if(this.reportList.items){
        return this.reportList.items.reports.planning;
      }
      return this.reportList;
    },
    other: function (){
      if(this.reportList.items){
        return this.reportList.items.reports.other;
      }
      return this.reportList;
    },
    dashboards: function (){
      if(this.reportList.items){
        return this.reportList.items.reports.dashboards;
      }
      return this.reportList;
    },
    featured: function (){
      if(this.reportList.items){
        return this.reportList.items.featured;
      }
      return this.reportList;
    },
    getISatComplianceIcon: function () {
      return this.sessionIsISatCompliant ? ['far', 'check-circle'] : ['fas', 'exclamation-triangle'];
    },
    getISatComplianceColor: function () {
      return this.sessionIsISatCompliant ? 'text-success' : 'text-danger';
    },
    getISatComplianceTitle: function () {
      return this.sessionIsISatCompliant ? '' : 'ISAT compliance record not found';
    },
    isStaff: function () {
      return storage.getBoolean(storage.IS_IRAPO);
    }
  },
  methods: {
    searchIds(){

      if(!this.search){
        return false;
      }
      const searchTerm = this.search?this.search.toLowerCase().trim():'';
      const a = this.flatten();
      const results = _.find(a, (o) => { if(o.shortcut) { return o.shortcut.toLowerCase().trim() === searchTerm} else if(o.id) { return o.id.toLowerCase().trim() === searchTerm } });
      if(!results) {
        this.notFound = true;
      } else{
        this.notFound = false;
        const obj = results.length >1? results[0]:results;
        if(obj.link){
          window.open(obj.link);
          return false;
        }
        const reportId = obj.id;
        this.$router.push(
          { name: 'report', params: { reportId } }
        ).catch(() => {
          console.log('Failed to push route');
        });
        return false;
      }
      return false;
    },
    flatten(){
      const newJson = [];
      const data = this.tableOfContents.reportData;
      for (const key in data)
      {
        const item = data[key];
        const reports = item.reports;
        for(const r in reports){
          const rItem = reports[r];
          rItem.category = item.name
          newJson.push(rItem);
        }
        if(item.groups){
          if(item.groups[0]){
            for(let i = 0; i < item.groups.length; i++){
              const groupReports = item.groups[i].reports;
              for(const rep in groupReports){
                const g = groupReports[rep];
                g.category = item.groups[i].name;
                newJson.push(groupReports[rep]);
              }
            }
          }
        }
      }
      return newJson;
    },
    onSlideStart(slide) {
      this.slide = slide;
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.slide = slide;
      this.sliding = false
    },
    scrollMeTo(refName) {
      const element = this.$refs[refName];
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },
    scrollToTop: function () {
      $('html,body').scrollTop(0);
    },
    async loadReports() {
      try {
        const results = await resource.get('api/w/mainpagereports');
        this.reportList = results;
      }
      catch (err) {
        analytics.exception(err, { fatal: true });
      }
    },
    doLogin: function () {
      oidcClient.signInPopup();
    },
  },
  created() {
    this.loadReports();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Jost:wght@500&display=swap');
  @import '../assets/app.styl'
  .white
    color white
  .backgroundRow
    min-height 200px
    margin-top 0px
    color black
    background-image: url('../assets/img/background-temp.jpg')
  .hide
    display none;
  .page
    padding-top 100px
  .icon
    width 50px
  .title
    font-weight bold
    text-align center
  .center
    text-align center
  .subtitle
    text-align left
    font-weight bold
  .spacer
    margin-top 10px
  .imageBanner
    text-align right
  .list
    font-size 11pt
  .sitemap
    font-size 12pt
  .subtext
    font-size 10pt
    padding-left 20px
    margin-bottom 10px
  .dashboards
    background-color #FFF
    display none
  .lock
    font-size 1 rem
    padding-left 3px
  .updated
    padding-bottom 10px
    font-size 10pt
  ol
    margin 0 0 0 0
  .card
    background-color: #fff
    overflow: hidden
    margin-bottom: 15px !important
  .card-header
    font-weight: bold
  .card-header img
    width: 100%
    height: 50px
    object-fit: cover
  .card-body
    display: flex
    flex-direction: column
    align-items: flex-start
    padding: 0px 5px 0px 0px
  .header-text
    font-size 15px
    padding-left 20px
    padding-top 20px
    font-weight bold

  .searchHeader
    font-family: 'Jost', sans-serif;
    vertical-align middle
  a:hover
    text-decoration underline
    cursor pointer
  a
    color #1139a6
  .user
    display: flex
    margin-top: auto
  .user img
    border-radius: 50%
    width: 40px
    height: 40px
    margin-right: 10px

  .areaItem
    margin-bottom 10px
  div#rdapp {
      display: flex;
      justify-content: center;
      flex-direction: column;
      .search-wrapper {
        width: 100%;
        position: relative;
        label {
          position: absolute;
          font-size: 12px;
          color: rgba(0,0,0,.50);
          top: 8px;
          left: 12px;
          z-index: -1;
          transition: .15s all ease-in-out;
        }
        input {
          width: 200px;
          padding: 4px 12px;
          color: rgba(0,0,0,.70);
          border: 1px solid rgba(0,0,0,.12);
          transition: .15s all ease-in-out;
          background: white;
          &:focus {
            outline: none;
            transform: scale(1.05);
            & + label  {
              font-size: 10px;
              transform: translateY(-24px) translateX(-12px);
            }
          }
          &::-webkit-input-placeholder {
              font-size: 12px;
              color: rgba(0,0,0,.50);
              font-weight: 100;
          }
        }
      }

      .wrapper {
        display: flex;
        max-width: 444px;
        flex-wrap: wrap;
        padding-top: 12px;
      }

      .card {
        box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
        max-width: 124px;
        margin: 12px;
        transition: .15s all ease-in-out;
        &:hover {
          transform: scale(1.1);
        }
        a {
          text-decoration: none;
          padding: 12px;
          color: #03A9F4;
          font-size: 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            height: 100px;
          }
          small {
            font-size: 10px;
            padding: 4px;
          }
        }
      }

      .hotpink {
        background: hotpink;
      }

      .green {
        background: green;
      }

      .box {
        width: 100px;
        height: 100px;
        border: 1px solid rgba(0,0,0,.12);
      }
      .v-center{
        vertical-align: middle;
      }
    }
.searchContainer
  height 75px
  border 1px solid black
  background-color #352D39
  color white
.searchWrapper
  vertical-align center
  height 75px
</style>
